import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Avatar,
    Box,
    Card,
    CardContent,
    Divider,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import CheckoutFileUpload from "./CheckoutFileUpload";
import { usePaymentMethod } from "../../Contexts/PaymentMethodContext";

const CheckoutPaymentMethod = ({
    handleFileUpload,
    base64String,
    selectedFile,
}) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const { selectedMethod, setSelectedMethod } = usePaymentMethod();

    const handlePaymentMethodSelect = method => {
        setSelectedMethod(method);
    };


    return (
        <Card sx={{ maxWidth: "full" }} elevation={1}>
            <CardContent>
                <Typography
                    variant="h6"
                    sx={{ padding: "16px", fontWeight: "bold" }}
                >
                    Payment Method
                </Typography>
                <form>
                    <Card
                        sx={{
                            maxWidth: "full",
                            border:
                                selectedMethod === "Cash On Delivery"
                                    ? "1px solid red"
                                    : "",
                        }}
                        elevation={1}
                        onClick={() => {
                            handlePaymentMethodSelect("Cash On Delivery");
                            setExpanded(false);
                        }}
                    >
                        <CardContent>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "16px",
                                    alignSelf: "flex-start",
                                }}
                            >
                                <Avatar
                                    variant="square"
                                    alt="COD"
                                    src="/images/cod.png"
                                    sx={{ width: 40, height: 40 }}
                                />
                                <Typography
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: "1 0 0",
                                    }}
                                >
                                    Cash On Delivery
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                    <Accordion
                        sx={{
                            borderRadius: "5px",
                            border:
                                selectedMethod === "KPay"
                                    ? "1px solid red"
                                    : "",
                        }}
                        expanded={expanded === "panel1"}
                        onChange={handleChange("panel1")}
                        onClick={() => {
                            handlePaymentMethodSelect("KPay");
                        }}
                    >
                        <AccordionSummary
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: "16px",
                                }}
                            >
                                <Avatar
                                    variant="square"
                                    alt="KPay"
                                    src="/images/Kpay.png"
                                    sx={{ width: 40, height: 40 }}
                                />
                                <Typography fullWidth sx={{ flexShrink: 0 }}>
                                    KPay
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <Box
                                sx={{
                                    display: "flex",
                                    padding: "16px 24px",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "16px",
                                    alignSelf: "stretch",
                                }}
                            >
                                <Typography>Account Name : </Typography>
                                <Typography>Account No : </Typography>
                                <Typography color={"secondary"}>
                                    Lorem ipsum dolor sit amet consectetur.
                                    Imperdiet eu dignissim quam id hac sagittis.
                                    Ultrices consectetur velit cursus porttitor
                                    phasellus amet velit.
                                </Typography>
                                <CheckoutFileUpload
                                    handleFileUpload={handleFileUpload}
                                    base64String={base64String}
                                    selectedFile={selectedFile}
                                />
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        sx={{
                            borderRadius: "5px",
                            border:
                                selectedMethod === "WavePay"
                                    ? "1px solid red"
                                    : "",
                        }}
                        expanded={expanded === "panel2"}
                        onChange={handleChange("panel2")}
                        onClick={() => handlePaymentMethodSelect("WavePay")}
                    >
                        <AccordionSummary
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    gap: "16px",
                                }}
                            >
                                <Avatar
                                    variant="square"
                                    alt="Wave Pay"
                                    src="/images/WavePay.png"
                                    sx={{ width: 40, height: 40 }}
                                />
                                <Typography fullWidth sx={{ flexShrink: 0 }}>
                                    Wave Pay
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <Box
                                sx={{
                                    display: "flex",
                                    padding: "16px 24px",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "16px",
                                    alignSelf: "stretch",
                                }}
                            >
                                <Typography>Account Name : </Typography>
                                <Typography>Account No : </Typography>
                                <Typography color={"secondary"}>
                                    Lorem ipsum dolor sit amet consectetur.
                                    Imperdiet eu dignissim quam id hac sagittis.
                                    Ultrices consectetur velit cursus porttitor
                                    phasellus amet velit.
                                </Typography>
                                <CheckoutFileUpload
                                    handleFileUpload={handleFileUpload}
                                    base64String={base64String}
                                    selectedFile={selectedFile}
                                />
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </form>
            </CardContent>
        </Card>
    );
};

export default CheckoutPaymentMethod;
